var version = "0.2.1";

var mapConfig = {
  'europe': {
    key: 'ISO3'
  },
  'european-union': {
    key: 'ISO3'
  },
  'france-academies': {
    key: 'id'
  },
  'france-departements-outre-mer': {
    key: 'code',
    projection: 'geoConicConformalFrance'
  },
  'france-departements-simplified': {
    key: 'code'
  },
  'france-departements': {
    key: 'code'
  },
  'france-regions-metropole-simplified': {
    key: 'code'
  },
  'france-regions-metropole': {
    key: 'code'
  }
};

function getConfig() {
  for (var item in mapConfig) {
    mapConfig[item].path = 'https://cdn.jsdelivr.net/npm/@alter-eco/geo@^' + version + '/dist/' + item + '.json';
  }

  return mapConfig;
}

export default getConfig;
